export async function loadExternalSlowInteraction(engine, refresh = true) {
    await engine.addInteractor("externalSlow", async (container) => {
        const { Slower } = await import("./Slower.js");
        return new Slower(container);
    }, refresh);
}
export * from "./Options/Classes/Slow.js";
export * from "./Options/Interfaces/ISlow.js";
